import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "various-abstract-content",
  "use": "various-abstract-content-usage",
  "viewBox": "0 0 29 44",
  "content": "<symbol viewBox=\"0 0 29 44\" xmlns=\"http://www.w3.org/2000/svg\" id=\"various-abstract-content\"><path d=\"M0 0h14v14H0V0zm15 0h14v14H15V0zM0 15h14v14H0V15zm15 0h14v14H15V15zM0 30h14v14H0V30zm15 0h14v14H15V30z\" fill=\"#e3000f\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol